/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormEditCreateUpdateStockFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/stock/create-update/form-edit-create-update-stock-field-dialog.component';
/* eslint-enable */

/**
 * Stock field implementation.
 */
export class FormEditStockFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateStockFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateStockFieldDialogComponent)
      .create(this.injector);
  }

}
